export default "__VITE_ASSET__nU$KLGAE__"